<div class="row">

  <div class="col-3">


    <h2 class="content-heading">
      Companies ({{this.searchService.foundCompanies.length}})
    </h2>

    <div class="row">

      <div class="col">

        <div class="block block-transparent">

          <div class="row">
            <div class="col-md-12" *ngFor="let company of this.searchService.foundCompanies; let i = index;">

              <a [routerLink]="['/companies', company._id]">

                <ui-company-block>

                  <div company-block-options>
                  </div>

                  <img company-block-logo style="background: white;" class="img-avatar" src="{{company.logoUrl}}" onError="this.src='/assets/img/avatars/company.jpg';">

                  <div company-name>
                    {{company.companyName}}
                  </div>

                  <div company-summary>

                    <!-- user type indicators -->
                    <span *ngIf="company.isOpportunity" class="badge btn-alt-primary">Opportunity</span>
                    <span *ngIf="company.isClient" class="badge btn-alt-success">Client</span>
                    <span *ngIf="company.isBuyer" class="badge btn-alt-info">Buyer/Investor</span>
                    <span *ngIf="company.isLawyer" class="badge btn-alt-danger">Lawyer</span>
                    <span *ngIf="company.isReferrer" class="badge btn-alt-warning">Referrer</span>
                    <span *ngIf="company.isClinicHost" class="badge btn-alt-secondary">Funder/Banker</span>
                    <span *ngIf="company.isAccountant" class="badge btn-alt-additional1">Accountant</span>
                    <span *ngIf="company.isSupplier" class="badge btn-alt-additional2">Business Services</span>

                  </div>

                </ui-company-block>

              </a>
            </div>


          </div>

        </div>
      </div>


    </div>

  </div>

  <div class="col-3">


    <h2 class="content-heading">
      Contacts ({{this.searchService.foundContacts.length}})
    </h2>


    <div class="row">

      <div class="col">
        <div class="block block-transparent">

          <div class="row">
            <div class="col-md-12" *ngFor="let contact of this.searchService.foundContacts; let i = index;">

              <a [routerLink]="['/contacts', contact._id]">
                <ui-user-block>

                  <div user-block-options>
                    <!-- <button class="btn btn-sm btn-warning" (click)="enableEditing(contact)">
                        <i class="fa fa-pencil"></i> Edit</button>
                      <button class="btn btn-sm btn-danger" (click)="deleteContact(contact)">
                        <i class="fa fa-trash"></i> Delete</button> -->
                  </div>

                  <div contact-logo>
                    <img style="background: white;" class="img-avatar img-avatar-thumb" src="{{contact.logoUrl}}" alt="" onError="this.src='/assets/img/avatars/company.jpg';">
                  </div>

                  <div contact-name>
                    {{contact.firstName}} {{contact.lastName}}
                  </div>
                  <div contact-summary>
                    <span *ngIf="contact.jobTitle">{{contact.jobTitle}} -</span> {{contact.companyName}}
                    <span *ngIf="contact.companies.length > 1"> - Other Companies : {{contact.companies.length - 1}}</span>
                  </div>

                </ui-user-block>
              </a>
            </div>

            <!-- </div> -->
          </div>

        </div>
      </div>


    </div>

  </div>

  <div class="col-3">

    <h2 class="content-heading">
      Opportunities ({{this.searchService.foundOpportunities.length}})
    </h2>

    <div class="row">

      <div class="col">
        <div class="block block-transparent">

          <div class="row">
            <div class="col-md-12" *ngFor="let project of this.searchService.foundOpportunities;">

              <a [routerLink]="['/projects', project._id]">

                <ui-company-block>

                  <div company-block-options>
                  </div>

                  <img company-block-logo style="background: white;" class="img-avatar" src="{{project.client.logoUrl}}" onError="this.src='/assets/img/avatars/company.jpg';">

                  <div company-name>
                    {{project.projectName}}
                  </div>

                  <div company-summary>

                    <span class="text-muted">{{ project.client.companyName | startCase }}</span>
                    <span class="text-muted"> - {{ project.opportunityStatus | startCase }}</span>


                  </div>

                </ui-company-block>

              </a>
            </div>

          </div>

        </div>
      </div>


    </div>
  </div>

  <div class="col-3">

    <h2 class="content-heading">
      Deals ({{this.searchService.foundDeals.length}})
    </h2>


    <div class="row">

      <div class="col">
        <div class="block block-transparent">

          <div class="row">
            <div class="col-md-12" *ngFor="let project of this.searchService.foundDeals;">

              <a [routerLink]="['/projects', project._id]">

                <ui-company-block>

                  <div company-block-options>
                  </div>

                  <img company-block-logo style="background: white;" class="img-avatar" src="{{project.client.logoUrl}}" onError="this.src='/assets/img/avatars/company.jpg';">

                  <div company-name>
                    {{project.projectName}}
                  </div>

                  <div company-summary>

                    <span class="text-muted">{{ project.client.companyName | startCase }}</span>
                    <span class="text-muted"> - {{ project.dealStatus | startCase }}</span>


                  </div>

                </ui-company-block>

              </a>
            </div>


          </div>

        </div>
      </div>


    </div>
  </div>



// WEBPACK FOOTER //
// ./client/app/features/search/search.component.html